import React from 'react';
import {Typography, Button, Grid} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CategoryIcon from '@mui/icons-material/Category';
import WorkIcon from '@mui/icons-material/Work';
import {getCategoryByValue, getJobTypeByValue} from "./JobCard";
import Box from "@mui/material/Box";
import "../CV/CV.css";

const JobSummaryCard = ({job, applicationState, hashedCode}) => {
    return (
        <Box>
            <Grid container direction="column" spacing={2}>
                {/* Job Location */}
                {
                    job.jobPlacement && job.jobPlacement.length > 0 ? (
                        <Grid item container alignItems="center" spacing={1}>
                            <Grid item>
                                <LocationOnIcon/>
                            </Grid>
                            <Grid item>
                                <Typography variant="body1" fontWeight="bold">
                                    Job Location
                                </Typography>

                                {
                                    job.jobPlacement && job.jobPlacement.length > 0 ? (job.jobPlacement.map((placement, index) => (
                                        <div key={index}>
                                            <Typography variant="body2" color="text.secondary">
                                                {placement}
                                            </Typography>
                                        </div>
                                    ))) : ""
                                }
                            </Grid>
                        </Grid>
                    ) : ""
                }

                {/* Job Category */}
                <Grid item container alignItems="center" spacing={1}>
                    <Grid item>
                        <CategoryIcon/>
                    </Grid>
                    <Grid item>
                        <Typography variant="body1" fontWeight="bold">
                            Job Category
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {getCategoryByValue(job.jobCategory)}
                        </Typography>
                    </Grid>
                </Grid>

                {/* Job Type */}
                <Grid item container alignItems="center" spacing={1}>
                    <Grid item>
                        <WorkIcon/>
                    </Grid>
                    <Grid item>
                        <Typography variant="body1" fontWeight="bold">
                            Job Type
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {getJobTypeByValue(job.jobType)}
                        </Typography>
                    </Grid>
                </Grid>

                {/* Apply Button */}
                <Grid item>
                    {
                        !applicationState ? (
                            <Button
                                href={`/ExternalCV?jobID=${hashedCode}&application=true`}
                                variant="contained"
                                fullWidth
                                className={"btn-primary-custom"}>
                                Apply for this job
                            </Button>
                        ) : ""
                    }
                </Grid>
            </Grid>
        </Box>
    );
};

export default JobSummaryCard;